(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naturhaar-faq"]) return;
  try {
    
  (function(){
    const nav = document.getElementById('nhfaq-nav');
    const panels = document.getElementById('nhfaq-panels');
    if(!nav || !panels) return;
    const navItems = nav.querySelectorAll('.nhfaq__nav-item');
    navItems.forEach(function(item){
      item.addEventListener('click', function(){
        const cat = item.dataset.category;
        navItems.forEach(function(i){ i.classList.toggle('is-active', i === item); });
        panels.querySelectorAll('.nhfaq__panel').forEach(function(p){
          p.classList.toggle('is-active', p.dataset.panel === cat);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naturhaar-home-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="nh-home-seed-"]').forEach(function(el){ fillSeeds(el); });
  function fillSeeds(el){
    if(!el) return;
    el.innerHTML = '';
    for(let i=0;i<22;i++){
      const sp = document.createElement('span');
      const size = 8 + Math.random()*10;
      sp.style.width = size+'px'; sp.style.height = (size*1.6)+'px';
      sp.style.left = (10+Math.random()*80)+'%'; sp.style.top = (10+Math.random()*80)+'%';
      sp.style.transform = 'translate(-50%,-50%) rotate(' + (Math.random()*360) + 'deg)';
      el.appendChild(sp);
    }
  }
  (function(){
    document.querySelectorAll('.nh-home-ing-card').forEach(function(card){
      const nameEl = card.querySelector('[id^="nh-home-ing-name-"]');
      const descEl = card.querySelector('[id^="nh-home-ing-desc-"]');
      const seedEl = card.querySelector('[id^="nh-home-seed-"]');
      const prevBtn = card.querySelector('[id^="nh-home-ing-prev-"]');
      const nextBtn = card.querySelector('[id^="nh-home-ing-next-"]');
      if(!nameEl) return;
      const data = [
        { name: nameEl.textContent, desc: descEl.textContent },
        { name: 'Sägepalme', desc: 'Dieser pflanzliche Extrakt unterstützt einen gesunden DHT-Spiegel über einen doppelten Wirkmechanismus. In Kombination mit Kürbiskernöl trägt er zu einer gesunden Kopfhautumgebung bei.' }
      ];
      let idx = 0;
      function render(){ nameEl.textContent = data[idx].name; descEl.textContent = data[idx].desc; fillSeeds(seedEl); }
      if(prevBtn) prevBtn.addEventListener('click', function(){ idx = (idx + data.length - 1) % data.length; render(); });
      if(nextBtn) nextBtn.addEventListener('click', function(){ idx = (idx + 1) % data.length; render(); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naturhaar-home-promo"] && !Shopify.designMode) return;
  try {
    
  (function(){
    const els = document.querySelectorAll('[id^="nh-home-timer-"]');
    function pad(n){ return String(n).padStart(2,'0'); }
    function tick(){
      const now = new Date();
      const end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
      let diff = Math.max(0, end - now);
      const h = Math.floor(diff / 3600000);
      const m = Math.floor((diff % 3600000) / 60000);
      const s = Math.floor((diff % 60000) / 1000);
      const label = pad(h) + ':' + pad(m) + ':' + pad(s);
      els.forEach(function(el){ el.textContent = label; });
    }
    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naturhaar-home-timeline"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.nh-home-tl-accordion').forEach(function(acc){
    const grid = acc.closest('.nh-home-tl-grid');
    const items = acc.querySelectorAll('.nh-home-tl-acc-item');
    const photoSlots = grid ? grid.querySelectorAll('.nh-home-tl-photo-slot') : [];
    function activate(index){
      items.forEach(function(item){ item.classList.toggle('is-open', +item.dataset.tlIndex === index); });
      photoSlots.forEach(function(slot){ slot.hidden = (+slot.dataset.tlIndex !== index); });
    }
    items.forEach(function(item){
      const btn = item.querySelector('.nh-home-tl-label-btn');
      if(!btn) return;
      btn.addEventListener('click', function(){ activate(+item.dataset.tlIndex); });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["naturhaar-product-page"]) return;
  try {
    

  document.querySelectorAll('.nh-gallery').forEach(function(gallery){
    const wrap = gallery.closest('.nh-media');
    const track = gallery.querySelector('.nh-gallery-track');
    const thumbRow = wrap ? wrap.querySelector('.nh-thumb-row') : null;
    if(!track || !thumbRow) return;
    const thumbs = thumbRow.querySelectorAll('.nh-thumb-btn');
    function setActive(i){
      thumbs.forEach(function(t){ t.classList.toggle('is-active', +t.dataset.index === i); });
    }
    thumbs.forEach(function(t){
      t.addEventListener('click', function(){
        const i = +t.dataset.index;
        track.scrollLeft = i * track.clientWidth;
        setActive(i);
      });
    });
    let nhScrollTimeout;
    track.addEventListener('scroll', function(){
      clearTimeout(nhScrollTimeout);
      nhScrollTimeout = setTimeout(function(){
        const i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(i);
      }, 100);
    });
  });

  function nhFillSeeds(el){
    if(!el) return;
    el.innerHTML='';
    for(let i=0;i<22;i++){
      const sp=document.createElement('span');
      const size=8+Math.random()*10;
      sp.style.width=size+'px'; sp.style.height=(size*1.6)+'px';
      sp.style.left=(10+Math.random()*80)+'%'; sp.style.top=(10+Math.random()*80)+'%';
      sp.style.transform=`translate(-50%,-50%) rotate(${Math.random()*360}deg)`;
      el.appendChild(sp);
    }
  }
  document.querySelectorAll('.nh-ingredient-card .nh-seed-circle').forEach(nhFillSeeds);

  document.querySelectorAll('.nh-testi-slider').forEach(function(slider){
    const track = slider.querySelector('.nh-testi-track');
    const prevBtn = slider.querySelector('.nh-testi-prev');
    const nextBtn = slider.querySelector('.nh-testi-next');
    const dotsWrap = slider.parentElement.querySelector('.nh-dots');
    if(!track) return;
    const slides = track.querySelectorAll('.nh-testi-card');
    const dots = dotsWrap ? dotsWrap.querySelectorAll('button') : [];
    function setActive(i){
      dots.forEach(function(d){ d.classList.toggle('active', +d.dataset.index === i); });
    }
    function goTo(i){
      i = Math.max(0, Math.min(slides.length - 1, i));
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }
    if(prevBtn) prevBtn.addEventListener('click', function(){
      const current = Math.round(track.scrollLeft / track.clientWidth);
      goTo(current - 1);
    });
    if(nextBtn) nextBtn.addEventListener('click', function(){
      const current = Math.round(track.scrollLeft / track.clientWidth);
      goTo(current + 1);
    });
    dots.forEach(function(d){ d.addEventListener('click', function(){ goTo(+d.dataset.index); }); });
    let nhTestiScrollTimeout;
    track.addEventListener('scroll', function(){
      clearTimeout(nhTestiScrollTimeout);
      nhTestiScrollTimeout = setTimeout(function(){
        setActive(Math.round(track.scrollLeft / track.clientWidth));
      }, 100);
    });
  });

  (function(){
    const pills=document.querySelectorAll('.nh-ing-pill');
    const nameEl=document.getElementById('nh-ing-name'), descEl=document.getElementById('nh-ing-desc');
    const photoSlots=document.querySelectorAll('.nh-ing-photo-slot');
    const prevBtn=document.getElementById('nh-ing-prev'), nextBtn=document.getElementById('nh-ing-next');
    if(!pills.length || !nameEl) return;
    let idx=0;
    function render(){
      const active=pills[idx];
      if(!active) return;
      nameEl.textContent=active.dataset.name;
      descEl.textContent=active.dataset.desc;
      pills.forEach(function(p,i){ p.classList.toggle('is-active', i===idx); });
      photoSlots.forEach(function(s){
        const match = +s.dataset.ingIndex === idx;
        s.hidden = !match;
        if(match){ const seed=s.querySelector('.nh-seed-circle'); if(seed) nhFillSeeds(seed); }
      });
    }
    pills.forEach(function(p,i){ p.addEventListener('click',function(){ idx=i; render(); }); });
    if(prevBtn) prevBtn.addEventListener('click',function(){ idx=(idx+pills.length-1)%pills.length; render(); });
    if(nextBtn) nextBtn.addEventListener('click',function(){ idx=(idx+1)%pills.length; render(); });
  })();

  (function(){
    const hidden=document.getElementById('nh-selected-variant');
    const radios=document.querySelectorAll('input[name="nh-bundle-radio"]');
    const gifts=document.querySelectorAll('.nh-gift');
    function applyTier(tier){
      radios.forEach(r=>{ r.closest('.nh-bundle').classList.toggle('is-selected', r.checked); });
      gifts.forEach(g=>{
        const locked = parseInt(g.dataset.gift,10) > tier;
        g.classList.toggle('is-locked', locked);
        g.querySelector('.nh-free-tag').hidden = locked;
        g.querySelector('.nh-lock-tag').hidden = !locked;
      });
    }
    radios.forEach(r=>r.addEventListener('change',()=>{
      if(!r.checked) return;
      hidden.value=r.value;
      applyTier(parseInt(r.dataset.tier,10));
    }));
    const checked=document.querySelector('input[name="nh-bundle-radio"]:checked');
    if(checked) applyTier(parseInt(checked.dataset.tier,10));
  })();

  (function(){
    const bar=document.getElementById('nh-sticky-bar');
    const anchor=document.getElementById('nh-add-cart-btn');
    if(!bar || !anchor) return;
    const io=new IntersectionObserver(([entry])=>{
      bar.classList.toggle('show', !entry.isIntersecting);
    },{threshold:0});
    io.observe(anchor);
  })();

  (function(){
    document.querySelectorAll('.nh-upsell-add').forEach(function(btn){
      const labelEl = btn.querySelector('.nh-upsell-add-label');
      const defaultLabel = labelEl.textContent;
      const addedLabel = btn.dataset.addedLabel;
      btn.addEventListener('click', function(){
        if(btn.classList.contains('is-loading') || btn.classList.contains('is-added')) return;
        btn.classList.add('is-loading');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({ items: [{ id: btn.dataset.variantId, quantity: 1 }] })
        })
        .then(function(res){ if(!res.ok) throw new Error('add failed'); })
        .then(function(){
          btn.classList.remove('is-loading');
          btn.classList.add('is-added');
          labelEl.textContent = addedLabel;
          setTimeout(function(){
            btn.classList.remove('is-added');
            labelEl.textContent = defaultLabel;
          }, 2000);
        })
        .catch(function(){
          btn.classList.remove('is-loading');
        });
      });
    });
  })();

  document.querySelectorAll('.nh-tl-accordion').forEach(function(acc){
    const grid = acc.closest('.nh-timeline-grid');
    const items = acc.querySelectorAll('.nh-tl-acc-item');
    const photoSlots = grid ? grid.querySelectorAll('.nh-tl-photo-slot') : [];
    function activate(index){
      items.forEach(function(item){ item.classList.toggle('is-open', +item.dataset.tlIndex === index); });
      photoSlots.forEach(function(slot){ slot.hidden = (+slot.dataset.tlIndex !== index); });
    }
    items.forEach(function(item){
      const btn = item.querySelector('.nh-tl-label-btn');
      if(!btn) return;
      btn.addEventListener('click', function(){ activate(+item.dataset.tlIndex); });
    });
  });


  } catch(e) { console.error(e); }
})();
})();
